import DataLoader from 'dataloader';
import hash from 'object-hash';
import { retryAsPromised } from 'retry-as-promised';

type CacheID = string;

export type DataloaderLoadKey = {
  query: string;
  params?: Record<string, unknown>;
};

const apiUrl = new URL(
  `https://${process.env.SANITY_ID}.apicdn.sanity.io/v2024-02-24/data/query/${process.env.SANITY_DATASET}`
);

const queryCache = new Map<CacheID, unknown>();

export const $globalSanityDataloader = new DataLoader(
  (keys: readonly DataloaderLoadKey[]) =>
    Promise.all(
      keys.map(({ query, params }) =>
        retryAsPromised(
          async () => {
            const cacheKey = `${hash(query)}-${hash(params ?? {})}`;
            if (queryCache.has(cacheKey)) return queryCache.get(cacheKey);
            const response = await fetch(apiUrl, {
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              body: JSON.stringify({
                query,
                params
              }),
              next: {
                revalidate: 60
              }
            });
            const data = await response.json();
            queryCache.set(cacheKey, data.result);
            return data.result;
          },
          {
            max: 3,
            backoffBase: 1000,
            backoffExponent: 1.5,
            report: (message, obj, err) => {
              if (err) {
                console.error(
                  `failed to fetch query (${query})`,
                  params,
                  message,
                  err
                );
              }
            }
          }
        )
      )
    ),
  {
    batchScheduleFn: (callback) => setTimeout(callback, 0),
    cacheKeyFn(key) {
      return `${hash(key.query)}-${hash(key.params ?? {})}`;
    }
  }
);
